import React, { Component } from 'react';

import styles from '../styles/pages/product-show.scss';

class ProductImageThumb extends Component {
    render() {
        return (
            <div className={`col-sm-4 col-xs-4 col-md-4 col-lg-4 ${styles.thumbnailContainer}`}>
                <div className={styles.thumbnail}>
                    <img
                        className={styles.productThumbs}
                        alt={this.props.productName}
                        src={this.props.imageUrl}
                        onClick={() => this.props.onClickThumbnail(this.props.imageNo)}
                    />
                </div>
            </div>
        );
    }
}

export default ProductImageThumb;



/** WEBPACK FOOTER **
 ** ./src/components/product/image-thumbnail.jsx
 **/